import { styled } from '@mui/system';
import { useCallback, useMemo, useRef, useState } from 'react';
import { debounce } from '../utils';
import { Box, Button, TextField, Typography } from '@mui/material';
import { ReactComponent as CloseKeyboardIcon } from '../images/close-keyboard.svg';

const TextareaWrapper = styled('div')({
    width: '100%',
    position: 'relative',
    textarea: {
        fontSize: '16px',
    },

    '.MuiInputBase-root': {
        paddingBottom: '28px',
    },

    '.MuiFormControl-root': {
        width: '100%',
    },

    // '.Mui-focused': {
    //     fieldset: {
    //         borderColor: `${colors.main}`,
    //     },
    // }
});

export const BottomBlock = styled(Box)(({ theme }) => ({
    position: 'absolute',
    bottom: '14px',
    right: '14px',

    display: 'flex',
    alignItems: 'center',
    gap: 20,
}));

const Counter = styled(Typography)({
    fontSize: '14px',
    lineHeight: '14px',
});

const CloseKeyboardButton = styled(Button)({
    minWidth: 44,
    width: 44,
    height: 44,
    padding: 0,

    borderRadius: 22,
});

const QuestionAnswerTextarea = ({ question, onAnswerSelect }) => {
    const inputRef = useRef(null);
    const [currentLength, setCurrentLength] = useState(0);
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const maxlength = 256;
    const id = question.id;

    const debouncedOnAnswerSelect = useMemo(() => debounce(onAnswerSelect, 200), [onAnswerSelect]);

    const checkIsValid = (value) => {
        if (!value) {
            return;
        }
        const length = value.split(',').filter((str) => str.trim() !== '').length;
        const isValidValue = !!(length && length >= 2);

        setIsValid(isValidValue);
        return isValidValue;
    };

    const handleChangeValue = useCallback(
        (event) => {
            let value = event.target.value.trim() ? event.target.value : undefined;

            setCurrentLength(event.target.value?.length);
            const isValidValue = checkIsValid(value);

            if (!isValidValue) {
                value = undefined;
            }
            debouncedOnAnswerSelect(id, value, question.question_type);
        },
        [debouncedOnAnswerSelect, id],
    );

    return (
        <TextareaWrapper>
            <TextField
                ref={inputRef}
                error={!isValid}
                multiline
                rows={6}
                inputProps={{ maxlength }}
                onChange={handleChangeValue}
                onFocus={() => setIsInputFocused(true)}
                onBlur={() => setTimeout(() => setIsInputFocused(false), 100)}
            />
            <BottomBlock>
                {currentLength > 200 && (
                    <Counter>
                        {currentLength}/{maxlength}
                    </Counter>
                )}
                {isInputFocused && window.innerWidth < 500 && (
                    <CloseKeyboardButton
                        aria-label="Закрыть клавиатуру"
                        variant="coloredOutlined"
                        onClick={() => inputRef.current?.blur()}
                    >
                        <CloseKeyboardIcon height={20} width={20} />
                    </CloseKeyboardButton>
                )}
            </BottomBlock>
        </TextareaWrapper>
    );
};

export default QuestionAnswerTextarea;
